(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["attilus-cross-sells-stickers"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cross-sells__custom-product .cross-sells__item-add').forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault();

    const variantId = this.getAttribute('data-add-item-id');
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add product');
      return response.json();
    })
    .then(data => {
      // Сохраняем флаг, что надо открыть корзину после перезагрузки
      sessionStorage.setItem('openQuickCartOnLoad', 'true');
      // Перезагружаем страницу
      location.reload();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  });
});

// После загрузки страницы проверяем флаг и имитируем клик по иконке корзины
window.addEventListener('load', function() {
  if (sessionStorage.getItem('openQuickCartOnLoad') === 'true') {
    sessionStorage.removeItem('openQuickCartOnLoad');
    
    if (!window.quickCartEnabled) return; // Если опция выключена, не открываем корзину
    
    // Ищем иконку корзины в хэдере, пример селектора:
    const cartIcon = document.querySelector('.header__icon-touch[data-js-cart-icon]');
    if (cartIcon) {
      cartIcon.click();
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
